import styled from 'styled-components';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

const graphicLung = {
  width: {
    iphone: functions.responsive.vw(
      148,
      356,
      breakpoints.iphone.width,
      breakpoints.ipad.width
    ),
    ipad: functions.responsive.vw(
      212,
      352,
      breakpoints.ipad.width,
      breakpoints.hd.width
    ),
    hd: functions.responsive.vw(
      220,
      284,
      breakpoints.hd.width,
      breakpoints.wxgaPlus.width
    ),
    wxgaPlus: functions.responsive.vw(
      92,
      172,
      breakpoints.wxgaPlus.width,
      breakpoints.fullHd.width
    ),
    fullHd: '172px',
  },
};

export const ReportAttenuationStyle = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;

  .carousel-component-active,
  .carousel-component-disabled {
    display: flex;
    flex-wrap: nowrap;

    .carousel-slide {
      .slide-content-card {
        background: ${colors.mostlyWhite};
        border-radius: 12px;
        padding: 24px 36px 20px;

        .graphic-lung-wrapper {
          margin: 0 auto 8px;
          max-width: ${graphicLung.width.iphone};
          position: relative;

          .section-info {
            cursor: pointer;
            opacity: 0;
            pointer-events: none;
            position: absolute;
            transform: translate(-50%, -50%);
            transition: opacity 400ms;

            &:before,
            &:after {
              background-color: ${colors.softBlue};
              content: '';
              display: block;
              position: absolute;
              top: 75%;
            }

            &:after {
              height: 1px;

              @media (min-width: ${breakpoints.ipad.width}px) {
                width: 52px;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                width: 24px;
              }

              @media (min-width: ${breakpoints.uxga.width}px) {
                width: 40px;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                width: 52px;
              }
            }

            &:before {
              border-radius: 50%;
              height: 8px;
              transform: translateY(-50%);
              width: 8px;
            }

            &.right-upper,
            &.right-middle,
            &.right-lower {
              &:before {
                right: -4px;
              }

              &:after {
                right: 0;
                transform: translateY(-50%) translateX(100%);
              }
            }

            &.left-upper,
            &.left-lower {
              &:before,
              &:after {
                top: 75%;
              }

              &:before {
                left: -4px;
              }

              &:after {
                left: 0;
                transform: translateY(-50%) translateX(-100%);
              }
            }

            &.right-upper {
              left: -15%;
              top: 20%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                left: -10%;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                left: -25%;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                left: -15%;
              }
            }

            &.right-middle {
              left: -5%;
              top: 70%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                left: 5%;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                left: -25%;
                top: 65%;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                left: -15%;
              }
            }

            &.right-lower {
              left: -20%;
              top: 80%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                left: -15%;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                left: -40%;
                top: 75%;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                left: -30%;
              }
            }

            &.left-upper {
              left: 120%;
              top: 20%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                left: 110%;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                left: 140%;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                left: 130%;
              }
            }

            &.left-lower {
              left: 115%;
              top: 80%;

              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                left: 115%;
              }

              @media (min-width: ${breakpoints.wxgaPlus.width}px) {
                left: 140%;
                top: 75%;
              }

              @media (min-width: ${breakpoints.fullHd.width}px) {
                left: 130%;
              }
            }

            &.show {
              opacity: 1;
            }

            .label,
            .value {
              ${fontFamily.sourceSansPro.bold}
              box-sizing: content-box;
              display: block;
              font-size: 18px;
              line-height: 20px;
              padding: 0 8px;
              width: fit-content;
            }

            .label {
              color: ${colors.veryDarkGrayishBlue};
            }

            .value {
              color: ${colors.softBlue};
            }
          }

          svg {
            display: block;
            height: auto;
            width: 100%;
          }
        }

        .slide-title {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.veryDarkGrayishBlue};
          font-size: 18px;
          line-height: 23px;
          margin-bottom: 4px;
          text-align: center;
        }

        .percentage-data {
          margin: 0 auto;
          max-width: ${graphicLung.width.iphone};
          position: relative;

          @media (min-width: ${breakpoints.ipad.width}px) {
            max-width: ${graphicLung.width.ipad};
          }

          @media (min-width: ${breakpoints.hd.width}px) {
            max-width: ${graphicLung.width.hd};
          }

          @media (min-width: ${breakpoints.fullHd.width}px) {
            max-width: ${graphicLung.width.fullHd};
          }

          &:after {
            background-color: ${colors.softBlue};
            content: '';
            display: block;
            height: 1px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, 50%);
            width: 100%;
          }

          .percentage-value {
            ${fontFamily.sourceSansPro.bold};
            ${zIndex.hills};
            background-color: ${colors.softBlue};
            border-radius: 50%;
            color: ${colors.veryPaleBlue};
            display: block;
            font-size: 18px;
            line-height: 24px;
            margin: 0 auto;
            padding: 16px 0;
            position: relative;
            text-align: center;
            width: 56px;
          }
        }
      }
    }
  }

  .carousel-component-active {
    width: 300%;

    .carousel-slide {
      transition: transform 600ms;
      width: 100%;

      .slide-content-card {
        .graphic-lung-wrapper {
          @media (min-width: ${breakpoints.ipad.width}px) {
            max-width: ${graphicLung.width.ipad};
          }

          @media (min-width: ${breakpoints.hd.width}px) {
            max-width: ${graphicLung.width.hd};
          }
        }

        .percentage-data {
          @media (min-width: ${breakpoints.ipad.width}px) {
            max-width: ${graphicLung.width.ipad};
          }

          @media (min-width: ${breakpoints.hd.width}px) {
            max-width: ${graphicLung.width.hd};
          }
        }
      }
    }
  }

  .carousel-component-disabled {
    width: 100%;

    .carousel-slide {
      transition: none;
      width: 33.33%;

      .slide-content-card {
        .graphic-lung-wrapper {
          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            max-width: ${graphicLung.width.wxgaPlus};
          }

          @media (min-width: ${breakpoints.fullHd.width}px) {
            max-width: ${graphicLung.width.fullHd};
          }
        }

        .percentage-data {
          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            max-width: ${graphicLung.width.wxgaPlus};
          }

          @media (min-width: ${breakpoints.fullHd.width}px) {
            max-width: ${graphicLung.width.fullHd};
          }
        }
      }
    }
  }

  .slide-navigation {
    height: 20px;
    position: absolute;
    top: 50%;
    transition: opacity 300ms;
    width: 20px;

    &.hide {
      display: none;
    }

    &.previous-slide {
      left: 24px;
      transform: translateY(-50%) rotate(90deg);
    }

    &.next-slide {
      right: 24px;
      transform: translateY(-50%) rotate(270deg);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.2;
    }

    svg {
      fill: ${colors.veryDarkGray};
    }
  }
`;
